module.exports = __webpack_public_path__ + "static/media/font_bold.3326e4d7.woff2";